import React from 'react';
import PropTypes from 'prop-types';
import BoxImage from './BoxImage';
import BoxTextBodyLinks from './BoxTextBodyLinks';

const Status = ({
  imageURL, name, id, title, body, trackingUrl, showReviewButton, hasFailed, isMobile,
}) => (
  <div className="status-container">
    <BoxImage imageURL={imageURL} showReviewButton={showReviewButton} isMobile={isMobile} />
    <div className="status">
      <h3>
        <span>{`${hasFailed || !name ? 'BOX ' : name} STATUS`}</span>
        {title}
      </h3>
      <p className="status-container__body">{body}</p>
      <BoxTextBodyLinks boxStatusId={id} trackingUrl={trackingUrl} title={title} body={body} />
    </div>
  </div>
);

Status.defaultProps = {
  imageURL: '',
  name: '',
  title: '',
  body: '',
  trackingUrl: '',
  showReviewButton: false,
  hasFailed: false,
  isMobile: false,
};

Status.propTypes = {
  imageURL: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  trackingUrl: PropTypes.string,
  showReviewButton: PropTypes.bool,
  hasFailed: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default Status;
